import { ElementType, Suspense } from 'react';

import Loader from '.';

const Loadable = (Component: ElementType) => (props: Record<string, unknown>) => {
  return (
    <Suspense fallback={<Loader />}>
      <Component {...props} />
    </Suspense>
  );
};

export default Loadable;
